import React from 'react';
import Popover from '@lib/components/Popover/Popover';
import IconButton, {
  IconButtonSizes,
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import Menu, { NavItem } from '@lib/components/Menu/Menu';
import styles from './ActionsMenu.module.scss';

interface Props<T> {
  actions: NavItem<T>[];
  disabled?: boolean;
  // Trigger icon — defaults to the horizontal three-dot menu.
  icon?: string;
  iconButtonClassName?: string;
  iconButtonRounded?: boolean;
  iconButtonSize?: IconButtonSizes;
  iconButtonType?: IconButtonTypes;
}

function ActionsMenu<T>(props: Props<T>) {
  const {
    actions,
    disabled,
    icon = 'more_horiz',
    iconButtonClassName,
    iconButtonType = IconButtonTypes.PrimaryOutlined,
    iconButtonRounded,
    iconButtonSize,
  } = props;
  if (!actions?.length) return null;
  const getBody = () => <Menu navItems={actions} listClassName={styles.body} />;
  return (
    <Popover body={getBody} placement="bottomRight" width={196}>
      {({ handleToggle, isOpen }) => (
        <div>
          <IconButton
            icon={icon}
            className={iconButtonClassName}
            rounded={iconButtonRounded}
            size={iconButtonSize}
            onClick={() => handleToggle()}
            isFocused={isOpen}
            type={iconButtonType}
            disabled={disabled}
            data-test-id="table__actions-menu"
          />
        </div>
      )}
    </Popover>
  );
}

export default ActionsMenu;
